
import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';
import { CardData } from '../../../tokens-and-interfaces';
import { TranslationModule } from '../../../i18n/translation-module';
import { Clipboard } from '@angular/cdk/clipboard';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { CommonAssociationCardContentComponent } from './common-associaon-card-content/common-association-card-content.component';
import { CardAction } from '../crm-object-association-panel/tokens-and-interfaces';

export type ActionFunc = (data: CardData) => void;

@Component({
  selector: 'crm-association-card',
  templateUrl: './association-card.component.html',
  styleUrls: ['./association-card.component.scss'],
  imports: [
    MatCardModule,
    GalaxyAvatarModule,
    MatIconModule,
    MatMenuModule,
    MatButtonModule,
    MatTooltipModule,
    TranslationModule,
    RouterLink,
    CommonAssociationCardContentComponent
],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [{ provide: Window, useValue: window }],
})
export class AssociationCardComponent implements OnInit {
  @Input({ required: true }) cardData!: CardData;
  @Input() showActionsMenu = true;
  @Input() showEditTagButton = true;
  @Input() showRemoveButton = true;
  @Input() actions: CardAction[] = [];
  @Output() removeClick = new EventEmitter();
  @Output() editTagsClick = new EventEmitter();

  fullBusinessAddress?: string;

  constructor(
    private clipboard: Clipboard,
    private snackbarService: SnackbarService,
    private window: Window,
  ) {}

  ngOnInit() {
    this.generateAddressString();
  }

  onRemove() {
    this.removeClick.emit();
  }

  onEditTags() {
    this.editTagsClick.emit();
  }

  copyToClipboard(email: string): void {
    this.clipboard.copy(email);
    this.snackbarService.openSuccessSnack('COMMON.SNACKBAR_MESSAGE.COPY_SUCCESS', { action: 'Close' });
  }

  openMailWindow(): void {
    this.window.open(
      `mailto:${this.cardData.email}`,
      'targetWindow',
      'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=900,height=600',
    );
  }

  generateAddressString() {
    // prettier-ignore
    if (this.cardData?.businessAddress) {
      this.fullBusinessAddress = '';
      const addy = this.cardData.businessAddress

      // build the address string
      if (addy.address1)
        this.fullBusinessAddress += addy.address1.trim() + ', ';
      if (addy.address2)
        this.fullBusinessAddress += addy.address2.trim() + ', ';
      if (addy.city)
        this.fullBusinessAddress += addy.city.trim() + ', ';
      if (addy.state)
        this.fullBusinessAddress += addy.state.trim() + ', ';
      if (addy.country)
        this.fullBusinessAddress += addy.country.trim() + ', ';
      if (addy.zip)
        this.fullBusinessAddress += addy.zip.trim() ;

      this.fullBusinessAddress = this.fullBusinessAddress.trim();
      if (this.fullBusinessAddress.endsWith(','))
        this.fullBusinessAddress = this.fullBusinessAddress.slice(0, -1);
    }
  }
}
